<template>
  <div class="w-full border-t-2 px-8 py-3 lg:flex justify-between items-center">
    <p class="mb-2 lg:mb-0">© Copyright Club Employés {{ currentYear }}</p>

<div class="flex">
  <a href="https://app.pipedrive.com/auth/login" class="mr-6 hover:text-gray-900">Pipedrive</a>
  <a href="https://www.zendesk.fr/login/" class="mr-6 hover:text-gray-900">Zendesk</a>
</div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";

const currentYear = ref<number>(new Date().getFullYear());
</script>
